import { Navigate, useParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { PrivacySettings } from "@/components/privacy-settings";
import { useSchoolBootstrap } from "@/hooks/use-school-bootstrap";
import { useAuthStore } from "@/stores/authStore";

export function TenantPrivacySettingsPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("privacy");
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { tenant } = useSchoolBootstrap(tenantSlug);

  if (!isAuthenticated || !user?.email) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  return (
    <main className="mx-auto max-w-3xl px-4 py-10" data-testid="privacy-settings">
      <h1 className="text-2xl font-semibold">{t("title")}</h1>
      <p className="mt-2 text-sm text-[var(--text-muted)]">
        {t("subtitle", { school: tenant?.name ?? tenantSlug })}
      </p>
      <div className="mt-8">
        <PrivacySettings tenantSlug={tenantSlug} userEmail={user.email} />
      </div>
    </main>
  );
}
